import { connect } from 'react-redux';

import ItemsPerPage from '../ItemsPerPage/ItemsPerPage';
import { getActiveListingPage } from '../../reduck/selectors';
import { changeNumberOfResultsPerPage } from '../../reduck/listingPagePages.reduck';
import uiLocale from '../../translations/UILocale.js';


const mapStateToProps = (state) => ({
  activeOption: getActiveListingPage(state).pageAttributes.m_results_per_page
    ? Number(getActiveListingPage(state).pageAttributes.m_results_per_page) : 20,
  itemsCount: getActiveListingPage(state).categoryTotalProductCount,
  options: [20, 30, 50],
  isPageLoading: state.listingPage.commonData.xhrStatus.pendingProductsRequest,
  showLabelStart: uiLocale.getString('component.pagination.label-show'),
  showLabelEnd: uiLocale.getString('component.pagination.label-end'),
  showLabelEndMobile: uiLocale.getString('component.pagination.label-mobile-end')
});


const mapDispatchToProps = (dispatch) => ({
  onOptionSelected: (selectedOption) => {
    dispatch(changeNumberOfResultsPerPage(String(selectedOption)));
  }
});


export default connect(mapStateToProps, mapDispatchToProps)(ItemsPerPage);
